import { countries } from 'countries-list';

import { Option } from 'types';

const useCountries = (country?: string) => {
  const getCountries = (): Option[] =>
    Object.entries(countries)
      .map(([key, item]) => ({
        value: item.name,
        label: item.name,
        additional: {
          countryKey: key,
        },
      }))
      .filter((item) => item);

  const getCountryCodeByName = (name: string) => {
    const result = Object.entries(countries).find(
      ([countryKey, countryData]) => countryData.name === name
    );

    return result ? result[0] : null;
  };
  const countryList = getCountries();
  const countryCode = country ? getCountryCodeByName(country) : null;

  return {
    countryCode,
    countryList,
  };
};

export { useCountries };
